import {apiClient} from 'core/apiClient';
import {CredentialsFIRS} from 'types';
import {ProfileCommonInfo, ProfileCountries} from 'types/profile';

export async function fetchProfileInfo(): Promise<ProfileCommonInfo> {
    const path = '/service/profile/common';
    return (await apiClient.get(path)).data as ProfileCommonInfo;
}

export async function fetchProfileCountries(): Promise<ProfileCountries[]> {
    const path = 'service/countries';
    return (await apiClient.get(path)).data;
}

export async function getCredentialsFIRS() {
    const path = 'uaa/legal-identity/firs-credentials';
    return (await apiClient.get<CredentialsFIRS>(path)).data;
}

export async function setCredentialsFIRS(payload: CredentialsFIRS) {
    const path = 'uaa/firs-credentials';
    return (await apiClient.post(path, payload)).data;
}
